import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ClToolbar extends Vue {
  /**
   * If true, disables gutter padding.
   */
  @Prop({
    type: Boolean,
    default: false
  })
  public disableGutters!: boolean;

  /**
   * The variant to use.
   */
  @Prop({
    type: String,
    default: 'regular',
    validator: x => ['dense', 'regular'].includes(x)
  })
  public variant!: string;
}
